import { useState } from "react";
import SearchResult from "./search-result.jsx";
import { Box, Text, Input, Button, HStack, VStack } from "@postenbring/hedwig-react";
import "./closest-pickup-point.scss";

const resolveCountry = (country) => {
    const normalizedCountry = String(country || "")
        .trim()
        .toUpperCase();

    if (["NO", "SE", "DK"].includes(normalizedCountry)) {
        return normalizedCountry;
    }

    return undefined;
};

export const ClosestPickupPoint = ({
    title,
    label,
    buttonText,
    mapLabel,
    noResultMessage,
    country,
    count,
    language,
    mapUrl,
}) => {
    const [postCode, setPostCode] = useState("");
    const [units, setUnits] = useState();

    const handleChange = (postCode) => {
        setPostCode(postCode);
    };

    function handleKeyDown(e) {
        if (e.keyCode === 13) {
            //Enter key
            lookupPickupPoint();
        }
    }

    function lookupPickupPoint() {
        const effectiveCountry = resolveCountry(country);
        if (!effectiveCountry) {
            setUnits([]);
            return;
        }
        const requestUrl =
            window.location.origin +
            window.location.pathname +
            "/_/service/no.posten.bring/closest-pickup-point?postalCode=" +
            postCode +
            "&count=" +
            count +
            "&country=" +
            effectiveCountry +
            "&language=" +
            language;

        fetch(requestUrl)
            .then((results) => {
                return results.json();
            })
            .then(
                (data) => {
                    const nextUnits = Array.isArray(data?.units) ? data.units : [];
                    setUnits(nextUnits);
                },
                () => {},
            );
    }

    return (
        <Box className="find-parcel-box" asChild>
            <VStack gap="24">
                <Text variant="h3-title">{title}</Text>
                <HStack gap="8" wrap>
                    <Input
                        className="new-input"
                        type="text"
                        label={label}
                        onChange={(postCode) => handleChange(postCode.target.value)}
                        value={postCode}
                        autoComplete="off"
                        maxLength={5}
                        onKeyDown={(key) => handleKeyDown(key)}
                    ></Input>
                    <Button
                        onClick={() => lookupPickupPoint()}
                        aria-controls="searchResults"
                        className="find-parcel-box__button"
                    >
                        {buttonText}
                    </Button>
                </HStack>
                <div id="searchResults" aria-live="polite">
                    {units && (
                        <SearchResult
                            units={units}
                            mapLabel={mapLabel}
                            noResultMessage={noResultMessage}
                            mapUrl={mapUrl}
                        />
                    )}
                </div>
            </VStack>
        </Box>
    );
};
